import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUpdateArchiveStatus = createSelector(
  [(store: RootState) => store.documentUpdate.updateArchiveStatus],
  (signStatus) => signStatus
);
